// @mui material components
import {
  Snackbar,
  Alert,
  Grid,
  Card,
  CircularProgress,
  Backdrop,
  Icon,
  // Dialog,
  // DialogContent,
  // DialogContentText,
  // DialogTitle,
  // DialogActions,
} from "@mui/material";

// Material Dashboard 2 React components
import MDBox from "theme/components/MDBox";
import MDTypography from "theme/components/MDTypography";
import MDButton from "theme/components/MDButton";
// import MDInput from "theme/components/MDInput";

// Material Dashboard 2 React example components
import DashboardLayout from "app/LayoutContainers/DashboardLayout";
import DashboardNavbar from "app/Navbars/DashboardNavbar";
import Footer from "theme/Footer";

import { useParams, useNavigate } from "react-router-dom";
import { useEffect, useState } from "react";
import axios from "axios.js";
import DataTable from "theme/Tables/DataTable";
import usePageTitle from "app/pageTitle";
import AppConfig from "appConfig";
import MessageDialog from "app/components/message_dialog";

function Team() {
  const pageTitle = "Team";
  usePageTitle(pageTitle);

  const navigate = useNavigate();
  const { id: reference } = useParams();

  const [showLoading, setShowLoading] = useState(false);
  const [open, setOpen] = useState(false);
  const [errorMsg, setErrMsg] = useState("");
  const [severity, setSeverity] = useState("");
  const handleClose = () => {
    setOpen(false);
    setErrMsg("");
  };

  const [showMessageComponentDialog, setShowMessageComponentDialog] = useState(false);
  const [messageDestinationType, setMessageDestinationType] = useState("group.agents");
  const [messageDestinationKey, setMessageDestinationKey] = useState(null);
  const [messageDestinationDescription, setMessageDestinationDescription] = useState(null);

  const [isTeamLead, setIsTeamLead] = useState(false);
  const [teamName, setTeamName] = useState(null);
  const [teamRef, setTeamRef] = useState(null);
  const [leads, setLeads] = useState([]);
  const [members, setMembers] = useState([]);

  const tableTeamLeadsColumns = [
    { Header: "Name", accessor: "name", align: "left" },
    { Header: "Phone Number", accessor: "phone_number", align: "left" },
  ];

  const tableTeamMembersColumns = [
    { Header: "Name", accessor: "name", align: "left" },
    // { Header: "Phone Number", accessor: "phone_number", align: "left" },
    // { Header: "Actions", accessor: "actions", align: "left" },
  ];

  const tableLeadTeamMembersColumns = [
    { Header: "Name", accessor: "name", align: "left" },
    { Header: "Phone Number", accessor: "phone_number", align: "left" },
    { Header: "Actions", accessor: "actions", align: "right" },
  ];

  const buildTeamLeadRows = (data) => {
    const rows = [];
    data.map((row) => {
      rows.push({
        name: row.agent,
        phone_number: row.phone_number,
      });
      return null;
    });

    return rows;
  };

  const buildLeadTeamMemberRows = (data) => {
    const rows = [];
    data.map((row) => {
      rows.push({
        name: row.agent,
        phone_number: row.phone_number,
        actions: (
          <MDButton
            size="small"
            variant="outlined"
            color="dark"
            iconOnly
            circular
            onClick={() => {
              setMessageDestinationType("group.agent");
              setMessageDestinationKey(row.reference);
              setMessageDestinationDescription(`Send message to ${row.agent}?`);
              AppConfig.messageDialogShown = true;
              setShowMessageComponentDialog(true);
            }}
          >
            <Icon sx={{ fontWeight: "bold" }}>mail</Icon>
          </MDButton>
        ),
      });
      return null;
    });

    return rows;
  };

  const buildTeamMemberRows = (data) => {
    const rows = [];
    data.map((row) => {
      rows.push({
        name: row.agent,
      });
      return null;
    });

    return rows;
  };

  useEffect(() => {
    const fetchData = async () => {
      setShowLoading(true);
      await axios
        .get(`agents/teams/teams/${reference}/fetch.json`)
        .then((result) => {
          // console.log(result);
          setShowLoading(false);
          if (result.data.status === "success") {
            setTeamName(result.data.data.title);
            setTeamRef(result.data.data.reference);
            setIsTeamLead(result.data.data.is_lead);
            const rowsLeads = buildTeamLeadRows(result.data.data.leads);
            let rowsMembers = buildTeamMemberRows(result.data.data.members);
            if (result.data.data.is_lead) {
              rowsMembers = buildLeadTeamMemberRows(result.data.data.members);
            }

            setLeads(rowsLeads);
            setMembers(rowsMembers);
          } else {
            setSeverity("error");
            setErrMsg(result.data.data.message);
            setOpen(true);
          }
        })
        .catch(() => {
          setShowLoading(false);
          setSeverity("error");
          setErrMsg(
            `Unable to complete request. ${
              navigator.onLine ? "" : "Make sure you have an active internet connection"
            }`
          );
          setOpen(true);
        });
    };

    fetchData();
  }, []);

  return (
    <DashboardLayout>
      <DashboardNavbar />
      <Backdrop
        sx={{ color: "#fff", zIndex: (theme) => theme.zIndex.drawer + 1 }}
        open={showLoading}
        onClick={handleClose}
      >
        <CircularProgress color="inherit" />
      </Backdrop>
      <Snackbar
        open={open}
        autoHideDuration={6000}
        onClose={handleClose}
        anchorOrigin={{ vertical: "top", horizontal: "center" }}
      >
        <Alert onClose={handleClose} severity={severity} sx={{ width: "100%" }}>
          {errorMsg}
        </Alert>
      </Snackbar>

      <MessageDialog
        destinationType={messageDestinationType}
        destinationKey={messageDestinationKey}
        description={messageDestinationDescription}
        displayState={showMessageComponentDialog}
        setDisplayState={setShowMessageComponentDialog}
      />

      <MDBox pt={3} pb={3}>
        <Card sx={{ width: "100%", marginTop: "15px" }}>
          <MDBox p={3}>
            <MDTypography variant="caption" fontWeight="light" textTransform="capitalize">
              Team
            </MDTypography>
            <MDTypography variant="h6" fontWeight="medium" textTransform="capitalize">
              {teamName}
            </MDTypography>
          </MDBox>
        </Card>
      </MDBox>

      <MDBox pt={3} pb={3}>
        <Grid container spacing={6}>
          <Grid item xs={12}>
            <Grid container spacing={3}>
              <Grid item xs={12} md={12} lg={12}>
                <MDBox>
                  <Card sx={{ height: "100%", marginTop: "0px" }}>
                    <MDBox p={3}>
                      <MDBox ml={2} mr={3}>
                        <Grid container spacing={3}>
                          <Grid item xs={6} md={6} lg={6}>
                            <MDTypography variant="h6" fontWeight="medium">
                              <Icon sx={{ cursor: "pointer" }} fontSize="medium" color="info">
                                local_police
                              </Icon>
                              <br />
                              Team Leads
                            </MDTypography>
                          </Grid>
                        </Grid>
                      </MDBox>
                      <MDBox mt={3}>
                        <DataTable
                          table={{ columns: tableTeamLeadsColumns, rows: leads }}
                          isSorted
                          canSearch={false}
                          entriesPerPage={false}
                          showTotalEntries
                          noEndBorder
                        />
                      </MDBox>
                    </MDBox>
                  </Card>
                </MDBox>
              </Grid>
            </Grid>
          </Grid>
        </Grid>
      </MDBox>

      <MDBox pt={3} pb={3}>
        <Grid container spacing={6}>
          <Grid item xs={12}>
            <Grid container spacing={3}>
              <Grid item xs={12} md={12} lg={12}>
                <MDBox>
                  <Card sx={{ height: "100%", marginTop: "0px" }}>
                    <MDBox p={1} pt={3}>
                      <MDBox ml={2} mr={3}>
                        <Grid container spacing={3}>
                          <Grid item xs={12} md={12} lg={12}>
                            <MDBox
                              display="flex"
                              justifyContent="space-between"
                              alignItems="center"
                            >
                              <MDTypography variant="h6" fontWeight="medium">
                                <Icon sx={{ cursor: "pointer" }} fontSize="medium" color="warning">
                                  people
                                </Icon>
                                <br />
                                Members
                              </MDTypography>
                              {isTeamLead ? (
                                <MDBox>
                                  <MDButton
                                    size="small"
                                    variant="outlined"
                                    color="dark"
                                    iconOnly
                                    onClick={() => {
                                      setMessageDestinationType("group.agents");
                                      setMessageDestinationKey(teamRef);
                                      setMessageDestinationDescription(
                                        "Send message to all group members"
                                      );
                                      AppConfig.messageDialogShown = true;
                                      setShowMessageComponentDialog(true);
                                    }}
                                  >
                                    <Icon sx={{ fontWeight: "bold" }}>email</Icon>
                                  </MDButton>
                                  &nbsp;&nbsp;
                                  <MDButton
                                    size="small"
                                    variant="outlined"
                                    color="success"
                                    iconOnly
                                    onClick={() => {
                                      navigate(`/teams/performance/${reference}`);
                                    }}
                                  >
                                    <Icon sx={{ fontWeight: "bold" }}>bar_chart</Icon>
                                  </MDButton>
                                </MDBox>
                              ) : (
                                <> </>
                              )}
                            </MDBox>
                          </Grid>
                        </Grid>
                      </MDBox>
                      <MDBox mt={1}>
                        {isTeamLead ? (
                          <DataTable
                            table={{ columns: tableLeadTeamMembersColumns, rows: members }}
                            isSorted
                            search={false}
                            entriesPerPage={false}
                            showTotalEntries
                            noEndBorder
                          />
                        ) : (
                          <DataTable
                            table={{ columns: tableTeamMembersColumns, rows: members }}
                            isSorted
                            search={false}
                            entriesPerPage={false}
                            showTotalEntries
                            noEndBorder
                          />
                        )}
                      </MDBox>
                    </MDBox>
                  </Card>
                </MDBox>
              </Grid>
            </Grid>
          </Grid>
        </Grid>
      </MDBox>
      <Footer />
    </DashboardLayout>
  );
}

export default Team;
